import { faA, faB, faC, faD, faE, faF } from '@fortawesome/pro-solid-svg-icons'

export const deliveryGroups = [
	{ value:'a', label:'A', icon:faA },
	{ value:'b', label:'B', icon:faB },
	{ value:'c', label:'C', icon:faC },
	{ value:'d', label:'D', icon:faD },
	{ value:'e', label:'E', icon:faE },
	{ value:'f', label:'F', icon:faF },
]